import React from 'react';

import type { FC } from 'react';

export const AccountCircle: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path d="M9.99984 1.66797C5.39984 1.66797 1.6665 5.4013 1.6665 10.0013C1.6665 14.6013 5.39984 18.3346 9.99984 18.3346C14.5998 18.3346 18.3332 14.6013 18.3332 10.0013C18.3332 5.4013 14.5998 1.66797 9.99984 1.66797ZM9.99984 5.0013C11.6082 5.0013 12.9165 6.30964 12.9165 7.91797C12.9165 9.5263 11.6082 10.8346 9.99984 10.8346C8.3915 10.8346 7.08317 9.5263 7.08317 7.91797C7.08317 6.30964 8.3915 5.0013 9.99984 5.0013ZM9.99984 16.668C8.30817 16.668 6.30817 15.9846 4.88317 14.268C6.2915 13.168 8.0665 12.5013 9.99984 12.5013C11.9332 12.5013 13.7082 13.168 15.1165 14.268C13.6915 15.9846 11.6915 16.668 9.99984 16.668Z" />
    </svg>
  );
};
